<template>
  <el-dialog class="register-dialog" :visible.sync="dialogVisible" :show-close="false" width="460px" append-to-body>
    <div class="content">
      <h3>二级建造师报考信息查询平台</h3>
      <div class="line"></div>
      <p>注册查询更多信息</p>
      <el-form ref="formRef" :rules="rules" class="form" :model="form" label-width="80px">
        <el-form-item label="手机号码" prop="mobile">
          <el-input v-model="form.mobile" placeholder="请输入您的手机号"></el-input>
        </el-form-item>
        <el-form-item label="初始密码" label-width="80px">
          <el-input v-model="form.pwd" disabled></el-input>
        </el-form-item>

        <el-button type="primary" style="width: 90%; background: rgb(16, 71, 143); border: none; height: 50px" @click="onSubmit">点击注册</el-button>
      </el-form>
      <submit-success-dialog ref="successRef"></submit-success-dialog>
    </div>
  </el-dialog>
</template>
<script>
import SubmitSuccessDialog from './submit-success-dialog'
import { phoneValidator } from '@/utils'
import { graduatePromot } from '@/api/index'
import md5 from 'js-md5'
export default {
  data() {
    var checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入您的手机号'))
      }
      if (!phoneValidator(value)) {
        return callback(new Error('手机号格式错误'))
      }
      callback()
    }
    return {
      dialogVisible: false,
      form: {
        mobile: '',
        pwd: '123456'
      },
      rules: {
        mobile: [{ validator: checkMobile, trigger: 'blur' }]
      }
    }
  },
  components: {
    SubmitSuccessDialog
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    onSubmit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          const gt = new Date().getTime().toString()
          graduatePromot({
            time: gt,
            encryPwd: md5(gt + 'verify'),
            mobile: this.form.mobile,
            originurl: window.location.origin + window.location.pathname,
            collegeName: '二级建造师',
            orign: '百度信息流',
            promotedAccount: '梓学教育吉re07-sl'
          }).then(res => {
            this.dialogVisible = false
            window._agl && window._agl.push(['track', ['success', { t: 3 }]])
            this.$refs.successRef.open(`注册成功，平台已为您转接人工服务。请稍后`)
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.register-dialog {
  ::v-deep .el-dialog {
    height: 300px;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
    .content {
      width: 460px;
      height: 300px;
      background: url(../../../assets/erjian/dialog_bg.png) no-repeat 100% 100%;
      h3 {
        padding-top: 8px;

        font-size: 24px;
        font-weight: bold;
        color: #fff;
        text-align: center;
      }
      .line {
        width: 110px;
        height: 2px;
        margin: 6px auto;
        background: #fff;
      }
      p {
        text-align: center;
        color: #fff;
        font-size: 18px;
      }
      .form {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
        .el-form-item__label {
          font-size: 16px;
          color: #333;
        }
        .el-input {
          width: 320px;
          .el-input__inner {
            border-radius: 0;
            border: 1px solid rgb(105, 105, 105);
          }
        }
      }
    }
  }
}
</style>
